export interface SponsorTestimonial {
  name: string;
  title: string;
  content: string;
}

export const sponsorTestimonials: SponsorTestimonial[] = [
  {
    name: "Sarah Johnson",
    title: "Financial Advisor",
    content: "SeniorThrive has transformed how I connect with my older clients. It's become an invaluable tool that demonstrates my commitment to their overall well-being."
  },
  {
    name: "Michael Chen",
    title: "Estate Planning Attorney",
    content: "My clients appreciate that I think beyond legal documents. SeniorThrive shows I care about their daily safety and independence."
  },
  {
    name: "Lisa Rodriguez",
    title: "Insurance Agent",
    content: "This platform perfectly complements my services. It's a meaningful way to show clients I'm invested in their long-term security and peace of mind."
  }
];